import { createContext, useEffect } from "react";
import { ThemeProvider } from "@mui/material";
import { Outlet } from "react-router-dom";
import useOrganizations, { OrganizationFetchConfig } from "@/features/organizations/useOrganizations";
import { Organization } from "@/types";
import useOrganizationId from "@/hooks/useOrganizationId";
import useOrganizationTheme from "@/features/organizations/useOrganizationTheme";
import MetaTags from "@/components/MetaTags";
import ReactGA from "react-ga4";

export type OrganizationProviderType = Partial<Organization>;
export const OrganizationProvider = createContext<OrganizationProviderType>({});

const TRACKING_ID = "G-LNKB084DYC"; //AEM TRACKING ID
ReactGA.initialize(TRACKING_ID);

const WebsiteProvider = (props: OrganizationFetchConfig) => {
  const organizationId = useOrganizationId();
  const { currentOrganization, getOrgDetails } = useOrganizations();
  const organizationTheme = useOrganizationTheme(currentOrganization);

  useEffect(() => {
    if (organizationId) {
      getOrgDetails(props);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationId]);

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.document.location.pathname,
      title: "Home",
    });
  }, []);

  return (
    <OrganizationProvider.Provider
      value={{
        ...currentOrganization,
      }}
    >
      <MetaTags name={currentOrganization?.title} title={currentOrganization?.title} description={currentOrganization?.slogan} image={currentOrganization?.logo} />
      <ThemeProvider theme={organizationTheme}>
        <Outlet />
      </ThemeProvider>
    </OrganizationProvider.Provider>
  );
};

export default WebsiteProvider;
